import { graphql, useStaticQuery } from "gatsby";

/**
 * Retrieves job category data from the server.
 * I am using the same structure as is being used for other listings queries
 * like Blog, News, Events, Resources, etc.
 *
 * @return {object} The job category data.
 */
const JobCategoryData = () => {
    const resourceData = useStaticQuery(graphql`
        query JobCategoryData {
            jobFilterData: allJob(
                sort: [{ sentDate: DESC }, { lastUpdatedDate: DESC }]
                filter: { jobState: { eq: "Open" }, internalOnly: { eq: false } }
            ) {
                By_Country: group(field: { locationCountry: SELECT }) {
                    fieldValue
                    edges {
                        node {
                            id: eId
                        }
                    }
                }
                By_Department: group(field: { category: SELECT }) {
                    fieldValue
                    edges {
                        node {
                            id: eId
                        }
                    }
                }
            }
        }
    `);

    return resourceData;
};

export default JobCategoryData;
